<template>
  <a-modal
    v-model:open="modalVisible"
    :title="modalTitle"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="900"
  :confirm-loading="confirmLoading"
  >
    <a-form :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="用户名" v-bind="validateInfos.username">
            <a-input v-model:value="form.username" class="custom-input" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="昵称" v-bind="validateInfos.nickName">
            <a-input v-model:value="form.nickName" class="custom-input" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="手机号" v-bind="validateInfos.phone">
            <a-input v-model:value="form.phone" class="custom-input" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮箱" v-bind="validateInfos.email">
            <a-input v-model:value="form.email" class="custom-input" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="角色" v-bind="validateInfos.roles">
            <a-select
              v-model:value="form.roles"
              mode="multiple"
              placeholder="请选择角色"
              class="custom-select"
              :loading="roleLoading"
            >
              <a-select-option v-for="role in roleList" :key="role.id" :value="role.id">
                {{ role.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="部门" v-bind="validateInfos.departmentId">
            <a-tree-select
              v-model:value="form.dtoUserInfo.departmentId"
              show-search
              placeholder="请选择部门"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="departmentTreeData"
              :filterTreeNode="filterTreeNode"
              tree-default-expand-all
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="岗位" v-bind="validateInfos.positions">
            <a-tree-select
              v-model:value="form.positions"
              multiple
              show-search
              placeholder="请选择岗位"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="positionTreeData"
              :filterTreeNode="filterTreeNode"
              tree-default-expand-all
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="员工状态">
            <a-select v-model:value="form.dtoUserInfo.employeeStatus" placeholder="请选择员工状态">
              <a-select-option :value="-1">离职</a-select-option>
              <a-select-option :value="1">在职</a-select-option>
              <a-select-option :value="2">休假</a-select-option>
              <a-select-option :value="3">停职</a-select-option>
              <a-select-option :value="4">退休</a-select-option>
              <a-select-option :value="5">实习</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="入职时间">
            <a-date-picker v-model:value="form.dtoUserInfo.hireDate" placeholder="请选择入职时间" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="个性签名">
            <a-input v-model:value="form.dtoUserInfo.signature" placeholder="请输入个性签名" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="性别">
            <a-select v-model:value="form.dtoUserInfo.sex" placeholder="请选择性别">
              <a-select-option :value="true">男</a-select-option>
              <a-select-option :value="false">女</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工号">
            <a-input v-model:value="form.dtoUserInfo.employeeNo" placeholder="请输入工号" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="上级">
            <a-input v-model:value="form.dtoUserInfo.supervisorId" placeholder="请输入上级用户ID" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="微信号">
            <a-input v-model:value="form.dtoUserInfo.weChat" placeholder="请输入微信号" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="QQ">
            <a-input v-model:value="form.dtoUserInfo.qq" placeholder="请输入QQ号" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="状态">
            <a-switch
              v-model:checked="form.status"
              checked-children="启用"
              un-checked-children="禁用"
            /> 
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="isNewUser ? '密码' : '密码（留空不修改）'" v-bind="validateInfos.PassWord">
            <a-input-password
              size="middle"
              :placeholder="isNewUser ? '请输入密码' : '留空则不修改密码'"
              v-model:value="form.PassWord"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="头像">
            <a-upload
              v-model:file-list="form.avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="beforeUpload"
            >
              <img
                v-if="form.avatarUrl"
                :src="form.avatarUrl"
                alt="avatar"
                style="width: 100%"
              />
              <div v-else>
                <PlusOutlined />
                <div style="margin-top: 8px">上传头像</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, reactive, watch } from 'vue';
import { PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { Form } from "ant-design-vue"; 
import { createUser, updateUser, getUserRoleList } from "../api/userapi";
import { getPositionTree } from "../api/organizational/position";
import { getDepartmentTree } from "../api/organizational/department";
import dayjs from 'dayjs';
const emit = defineEmits(['ok', 'cancel']);

const useForm = Form.useForm;

// 是否为新增用户模式（控制密码是否必填）
const isNewUser = ref(true);

// 表单数据
const form = reactive({
  username: "",
  id: 0,
  nickName: "",
  PassWord: "",
  phone: "",
  email: "",
  roles: [],
  positions:[],
  status: true,
  avatar: [],
  avatarUrl: "",
 dtoUserInfo:{ 
    departmentId: "",
    departmentName: "",
    employeeStatus: 1,
    hireDate: null,
    signature: "",
    sex: null,
    supervisorId: null,
    employeeNo: "",
    weChat: "",
    qq: "",
    id: 0
  }
});

// 表单验证规则
const formRules = reactive({
  username: [
    { required: true, message: "请输入用户名" },
    { min: 3, message: "用户名至少3个字符" },
  ],
  nickName: [{ required: true, message: "请输入昵称" }],
  phone: [
   { required: true, message: "请输入手机号" },  
  {  pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号" }],
  email: [ 
    { type: "email", message: "请输入有效的邮箱地址" },
  ], 
  roles: [ 
      { required: true, message: "请选择角色" },   
  ], positions: [ 
      { required: true, message: "请选择岗位" },   
  ],
  departmentId: [ 
      { required: true, message: "请选择岗位" },   
  ],
  PassWord: [
    {
      validator: (rule, value) => {
        if (isNewUser.value && !value) {
          return Promise.reject("请输入密码");
        }
        return Promise.resolve();
      },
    },
  ],
});

// 表单验证
const { validate: validateForm, validateInfos } = useForm(form, formRules);

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: "用户管理"
  },
  user: {
    type: Object,
    default: null
  },
  roleList: {
    type: Array,
    default: () => []
  },
  roleLoading: {
    type: Boolean,
    default: false
  }
});

// 内部状态
const modalVisible = ref(false);
const modalTitle = ref("用户管理");
const confirmLoading = ref(false);
const roleLoading = ref(false);
const roleList = ref([]);
const positionTreeData = ref([]);
const departmentTreeData = ref([]);
// 监听props变化
watch(() => props.visible, (newVal) => {
  modalVisible.value = newVal;
  if (newVal) {
    loadRoleList();
    loadPositionList();
    loadDepartmentList();
  }
});

watch(() => props.title, (newVal) => {
  modalTitle.value = newVal;
});

watch(() => props.user, (newVal) => {
   // 设置新增/编辑模式标志
  isNewUser.value = !newVal.id;
   // 重置表单 
  if (newVal.id) {
    console.log('编辑'+newVal);
    // 填充表单数据
    const userInfo = newVal.dtoUserInfo || {};
    Object.assign(form, {
      id: newVal.id,
      username: newVal.name,
      nickName: newVal.nickName,
      phone: newVal.phone,
      email: newVal.email,
      roles: newVal.roles.map((role) => role.id),
       positions: newVal.positions.map((role) => role.id),
      status: newVal.status == 1,
      avatar: [],
      avatarUrl: newVal.avatar || "",
      dtoUserInfo:{ 
        departmentId: userInfo.departmentId || "",
        departmentName: userInfo.departmentName || "",
        employeeStatus: userInfo.employeeStatus !== undefined ? userInfo.employeeStatus : 1,
        hireDate: userInfo.hireDate ? dayjs(userInfo.hireDate) : null,
        signature: userInfo.signature || "",
        sex: userInfo.sex,
        supervisorId: userInfo.supervisorId,
        employeeNo: userInfo.employeeNo || "",
        weChat: userInfo.weChat || "",
        qq: userInfo.qq || "",
        id: userInfo.id || 0
      }
    });
  } else {
     console.log('新增'+newVal);
    Object.assign(form, {
      username: "",
      id: 0,
      nickName: "",
      phone: "",
      email: "",
      roles: [],
      positions:newVal.positions?.map((role) => role.id),
      status: true,
      avatar: [],
      avatarUrl: "",
      dtoUserInfo:{ 
        departmentId: "",
        departmentName: "",
        employeeStatus: 1,
        hireDate: null,
        signature: "",
        sex: null,
        supervisorId: null,
        employeeNo: "",
        weChat: "",
        qq: "",
        id: 0
      }
    });
  }
});

// 头像上传前处理
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("只能上传JPG/PNG格式的图片!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("图片大小不能超过2MB!");
  }
  if (isJpgOrPng && isLt2M) {
    // 读取文件并预览
    const reader = new FileReader();
    reader.onload = (e) => {
      form.avatarUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }
  return false; // 不自动上传
};

// 加载角色列表
const loadRoleList = async () => {
  roleLoading.value = true;
  try {
    const response = await getUserRoleList();
    if (response && response.code === 200 && response.data) {
      roleList.value = response.data.map((role) => ({
        id: role.key,
        name: role.value,
        value: role.key,
      }));
    }
  } catch (error) {
    console.error("获取角色列表失败:", error);
    message.error("获取角色列表失败: " + error.message);
  } finally {
    roleLoading.value = false;
  }
};
const loadPositionList = async () => {
  roleLoading.value = true;
  try {
    const response = await getPositionTree();
    if (response && response.code === 200 && response.data) {
      positionTreeData.value = convertToTreeData(response.data);
    }
  } catch (error) {
    console.error("获取岗位列表失败:", error);
    message.error("获取岗位列表失败: " + error.message);
  } finally {
    roleLoading.value = false;
  }
};
const loadDepartmentList = async () => {
  roleLoading.value = true;
  try {
    const response = await getDepartmentTree();
    if (response && response.code === 200 && response.data) {
      departmentTreeData.value = convertToTreeData(response.data);
    }
  } catch (error) {
    console.error("获取部门列表失败:", error);
    message.error("获取部门列表失败: " + error.message);
  } finally {
    roleLoading.value = false;
  }
};

const convertToTreeData = (data) => {
  if (!data) return [];
  const traverse = (node) => {
    if (!node) return null;
    const treeNode = {
      value: node.id,
      title: `${node.name} - ${node.code}`,
      key: node.id
    };
    if (node.children && node.children.length > 0) {
      treeNode.children = node.children.map(child => traverse(child)).filter(child => child !== null);
    }
    return treeNode;
  };
  return traverse(data) ? [traverse(data)] : [];
};

const filterTreeNode = (inputValue, treeNode) => {
  return treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
};

const findPositionNameById = (id, treeData) => {
  if (!treeData || !Array.isArray(treeData)) return null;
  for (const node of treeData) {
    if (node.value === id) {
      return node.title.split(' - ')[0];
    }
    if (node.children && node.children.length > 0) {
      const found = findPositionNameById(id, node.children);
      if (found) return found;
    }
  }
  return null;
}; 

// 处理确认
const handleOk = () => {
  validateForm()
    .then(async () => {
      if(!form.dtoUserInfo.departmentId){
           message.error("请选择部门！");
            return;
      }
      // 新增用户时密码必填
      if (!props.user?.id && !form.PassWord) {
        message.error("新增用户时密码不能为空！");
        return;
      }
      try {
        confirmLoading.value = true;
        var roles = roleList.value.filter((role) => form.roles.includes(role.id));
        var positions = [];
        if (form.positions && form.positions.length > 0) {
          form.positions.forEach(posId => {
            var posName = findPositionNameById(posId, positionTreeData.value);
            if (posName) {
              positions.push({ id: posId, name: posName });
            }
          });
        }
        const userData = {
          id: form.id,
          name: form.username,
          nickName: form.nickName,
          PassWord: form.PassWord,
          phone: form.phone,
          email: form.email,
          dtoUserInfo:form.dtoUserInfo,
          roles: roles.map((role) => ({ id: role.id, name: role.name })),
          positions: positions,
          status: form.status,
          headImgs: form.avatarUrl
            ? [{ key: "avatar", value: form.avatarUrl }]
            : [],
        };

        let result;
        // 如果是新增用户，id传0，后端会自动生成雪花ID
        if (!props.user?.id) {
          userData.id = 0;
          result = await createUser(userData);
        } else {
          // 编辑用户
          result = await updateUser(userData);
        }

        if (result && result.code == 200) {
          message.success(props.user ? "用户信息更新成功" : "用户添加成功");
          emit('ok', userData);
        } else {
          message.error(props.user ? "用户信息更新失败" : "用户添加失败");
        }
      } catch (error) {
        console.error("操作失败:", error);
        message.error(props.user ? "用户信息更新失败: " + error.message : "用户添加失败: " + error.message);
      } finally {
        confirmLoading.value = false;
      }
    })
    .catch((err) => {
      console.log("表单验证失败:", err);
    });
};

// 处理取消
const handleCancel = () => {
    Object.assign(form, {
      username: "",
      id: 0,
      nickName: "",
      phone: "",
      email: "",
      roles: [],
      positions:[],
      status: true,
      avatar: [],
      avatarUrl: "",
      dtoUserInfo:{ 
        departmentId: "",
        departmentName: "",
        employeeStatus: 1,
        hireDate: null,
        signature: "",
        sex: null,
        supervisorId: null,
        employeeNo: "",
        weChat: "",
        qq: "",
        id: 0
      }
    });
  emit('cancel');
};
</script>